<template>
	<v-card outlined 
		
		style = "width:100%; height:100%; object-fit: fill;   border-color: grey " 
	>
		<v-card-title 			
			class = "justify-center pa-0 caption light-green darken-1 white--text vue-draggable-handle"
		>
			<v-spacer></v-spacer>			
			<span
				v-text="$ml.get('recognized')" 
			></span>
			<v-spacer></v-spacer>
			<v-icon
				small
				class  = "mx-1"
				color  = "white"
				v-text = "'mdi-file-percent'"
				@click = "dialog_confidence = !dialog_confidence"
				v-show = "show.edit_face"
			></v-icon>
			<!-- <v-icon
				class  = "mx-2"
				color  = "primary"
				v-text = "'mdi-view-list'"
				@click = "open_modal_traineds = !open_modal_traineds"
				v-show = "show.edit_face"
			></v-icon> -->
			<v-btn 
				x-small 
				 
				icon 
				class 	= "error"
	          	@click 	= "$emit('close_component', layout_id)"       
	          	v-show  = "show.edit_face"   					
	        >
	        <!-- show.close &&  -->
		        <v-icon 
		          	x-small 
		          	color="white" 
		          	class="ml-0" 
		          	outlined
		          	v-text = "'mdi-close'"

		        ></v-icon>
	      	</v-btn>		
		</v-card-title>
		<v-divider></v-divider>
		<v-card-subtitle>
			<v-text-field 
				v-model="search" 
				:label="$ml.get('search')" 
				prepend-inner-icon="mdi-text-box-search-outline" 
				class="pa-0 px-3"
				dense 
				hide-details
				outlined
			></v-text-field>

			
			<!-- v-on:keyup.enter v-on:keyup.enter="send"-->
			
		</v-card-subtitle>
		<v-divider></v-divider>
		<v-card-text 
			class 	= "pa-0 no-drag"
			style 	= "width:100%; height:100%; object-fit: fill;" 
			ref 	= "card_detected_face"
		>
				<v-item-group >
					<v-container fluid 
						class   = "pt-0 pb-5 pt-1 overflow-y-auto"  
						id 		= "scroll-target"  
						:style  = "{ overflowX:'hidden', height: height+'px' }"
						 
					> <!-- 18vh -->
					<!-- height: 200px -->
						<v-row 
							v-scroll:#scroll-target="onScroll"  :style="{height: height +'px'}"
							dense
						>
						
						<!-- style="height:20vh;"  -->
							<v-col 
								v-for="n in list.slice().reverse()" 
								@click="sel(n)" 
								:key="n.id" 
								cols="auto"  
								sm="auto" 
								lg="auto" 
								md="auto" 
								xl="auto" 
								style="justify: center;"
							>
								<v-item v-slot:default="{ active, toggle }">
									<v-card 
										:color="active ? 'primary' : '' "  
										dark  
										style="width:70px"  
										@click="toggle" 
										class="pl-1 ma-0" 
										outlined
									>
										<p 
											class = "pa-0 ma-0 text-center" 
											style = "font-size: 70%; line-height: 110%"
										>{{n.prediction}}</p>
										  <v-scroll-y-transition>							                  
							                 	<v-img  
							                 		:src="n.thumbnail" 
							                 		@error="n.thumbnail = '/img/no_img_found.png'"
							                 		width="60" 
							                 		height="64"
							                 	></v-img>
							                  <!-- 48 -->
							                  <!-- 64 -->
							                </v-scroll-y-transition>
							                <v-divider></v-divider>							                 
							                <p 
							                	class="pa-0 ma-0" 
							                	style="font-size: 70%; line-height : 150%"
							                >
							            		{{n.timestamp}}
							            	</p>
									</v-card>
								</v-item>
							</v-col>
						</v-row>	
					</v-container>
					<show 
						:info_to_component 	= "item"
						@close 				= "close_modal($event)"
					></show>
				</v-item-group>
					<!-- v-on:change_page="page=$event" -->
			<v-bottom-navigation
				height="40"
			 	dense>
					<v-btn text :disabled="true">
				    <span>
						{{ $ml.get('number_items') }}:
				    	{{pagination.items}}
				    </span>
					</v-btn>				    
					
			     		<!-- class="col-md-4" -->
			     	<v-pagination
				      	v-model="page"					 
					    :length="pagination.total"
					    :total-visible="pagination.visible"
					    dense
				    ></v-pagination>					
			</v-bottom-navigation>
		</v-card-text>
				<!-- <v-card-actions>
					
		</v-card-actions> -->
		<!-- <trained
			:open_modal = "open_modal_traineds"
			@close 		= "open_modal_traineds = $event"
		></trained> -->
		<v-dialog v-model="dialog_confidence" width="300">
		<v-card outlined>
  			<v-card-title v-text="$ml.get('confidence')" class="justify-center pa-1 body-1 secondary"></v-card-title>
  			<v-divider></v-divider>
  			<v-card-text class="pa-2">
  				<v-text-field
  					outlined
  					v-model.number="confidence"
  					:label="$ml.get('enter_value')"
  					type="number"
  					hide-details
  					dense
  				></v-text-field>
  			</v-card-text>
  			<v-divider></v-divider>
  			<v-card-actions>
  				<v-spacer></v-spacer>
  				<v-btn x-small
  					color="primary"
  					v-text="$ml.get('save')"
  					@click="save_confidence"
  				></v-btn>
  				<v-btn x-small
  					color="error"
  					v-text="$ml.get('close')"
  					@click="dialog_confidence = false"
  				></v-btn>
  			</v-card-actions>
  		</v-card>
  		</v-dialog>
	</v-card>
</template>
<script>
import axios 	from 'axios'
import moment 	from 'moment-timezone';
import show 	from '@/components/face/show_data'; 
import EventBus from '@/event-bus'
// import trained from '@/components/face/traineds.vue';
	export default{
		name 	   : 'recognized_face',
		components : {
			show,
			// trained
		},// components
		props:[	
			// 'search', 
			'search_type', 
			// 'paginate', 
			'layout', 
			'to_confidence',
			'layout_id'
		],
		data: () =>({
			offsetTop 	: 0,
			select 		: '',
			// height_d: 0,
			faces 		: [],
			faces_last 	: [],
			item 		: [],
			list_search : [],
			height 		: 0,
			// search:'',
			pagination :{
				visible : 5,
				total 	: 0,			
				items 	: 0,
				found 	: true,
				
			},
			page 				: 1,
			search 				:'',
			height 				: 0,
			confidence 			: 0.20, // default
			list_devices 		: [],
			open_modal_traineds : false,
			dialog_confidence 	: false,
			bus  				: {},
			show 				: {
				close 		: true,
				edit_face 	: true, 
			},
		}),

		created(){

			if (this.to_confidence){
				this.confidence = this.to_confidence;
			}
			
			if (!this.$store.getters["auth/permission"](this.$route.name || "face", "can_edit", "face")) { // !this.$Helper.current_auth_user(this.currentUser, {roles : [1, 2]})
      			this.show.edit_face = false; // close      			
      		}
		}, // created


		watch:{
			search: function(v){
				if (v) {
					this.search_list();
				}
			},
			paginate: function(pg){
				this.list_faces(pg);

			}, // paginate

			layout:function(v){
				this.onResize();
			}, //layout

			page: function(val){
				this.list_faces(val);
			}, // pages
		},
		methods:{
			onScroll (e) {
	    		this.offsetTop = e.target.scrollTop
	  		},

	  		sel(v){
	  			let val = v;
	  			this.item = val;
	  			//console.log(this.item, v, 'id_tracker')
	      	},

	      	close_modal(val){
	      		// console.log('close_modal')
	      		this.$nextTick(()=>{

	      			this.item = null;
	      		})
	      	},

	  		list_faces(pag=1){ //get faces 
      			axios.defaults.withCredentials= true
      			const api = this.$URL_face + '/api/face/listrecognizedfaces/?page=' + pag 
      			
      			axios.get(api).then( response => {
      				let items 		= response.data.results;
      				let item 		= response.data;
      				item.number 	= item.results.length;
      				let vm 			= this;
      				let pags		= item.count / 30;
      				let decimal 	= "";      				
      				if ((pags + "").split(".").length > 0) {
      					decimal 	= (pags+"").split(".")[1];
      					if (decimal > 5) {
      						pags 	= parseInt(pags + 1);
      					}
      				}
      				item.pages		= parseInt(pags);

      				items.forEach(function (arr_face, idx_face){
      					if (arr_face && arr_face.host_id) {
      						arr_face.device = vm.render_device(arr_face.host_id);
      					}
      				});

      				this.faces_last = items;

      				this.pagination = {
      					visible: 5,
						total: item.pages,			
						items: item.number,
						found: true,
      				};
      				// this.$emit('change_pagination', to_paginate);
      				
      				console.log(response.data.results)
	      		}).catch(error => {
	      			console.log(error , 'error recognized_face');
	        		this.errorMsg = 'No user or no location!';
	        		this.data = [];
	      		})

	      		},// list faces
	  		//http://localhost:8004/api/face/listfaces/
	  		search_list(){
	  			axios.defaults.withCredentials = true
	      			const api = this.$URL_face + '/api/face/listrecognizedfaces/?search_name=' + this.search
	      			
	      			axios.get(api).then(response => {
	      				console.log(response.data.results);
	      				let items 	= response.data.results
	      				let item 	= response.data;
	      				item.number = item.results.length;
	      				item.pages	= parseInt(item.count/30);
	      				let vm 		= this;
	      				items.forEach(function (arr_search, idx_search){
	      					if (arr_search && arr_search.host_id) {
	      						arr_search.device = vm.render_device(arr_search.host_id);
	      					}
      					});
	      				this.list_search = items;
	      				this.pagination  = {
      					visible: 5,
						total: item.pages,			
						items: item.number,
						found: true,
      				}

	      		}).catch(error => {
	        		this.errorMsg = 'No user or no location!'
	        		this.data = []
	      		})

	  		}, // search list

	  		onResize(val) {				
			 	if (this.$refs.card_detected_face) {
			 		this.height = this.$refs.card_detected_face.clientHeight - 140; // 145
				}

			}, //on Resize

			render_device(val){
				if (this.list_devices && this.list_devices.length > 0) {
					let vm 	   = this,
						device = ''	;

					const find = vm.list_devices.some( function (dev, idx_dev){
						if (dev.deviceId == val) {
							device = dev.name;
							return true
						}
					}) 

					return device;
				}
				return '';
			}, // render_device

			save_confidence(){
				let Confidence  = JSON.stringify(this.confidence);
				localStorage.setItem('confidence_face', Confidence);
				this.$confidence = Confidence; 
				EventBus.$emit('notifications_modal', {
					type: 'saved',
					message : ' confidence :' + Confidence,				
				})
				this.dialog_confidence = false;
			},

      	}, // methdos
  		computed:{
  			list:function(){
  				let socket 		= this.faces;
				let lasts		= this.faces_last;
				let l_search 	= this.list_search;
				let list 		= [], 
					list1 		= [], 
					order 		= [];
				let confd 		= this.confidence;



				let test 		= {

	            "id_tracker": 123,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "prediction": "name",
	            "confidence": "0.5",
            	"num_dets": 1,
            	"trained_thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-25/1585121263621/thumbnail/982614f7-bfe.jpg",
	            "timestamp" : moment(parseInt("1585054443788", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	            let test1={

	            "id_tracker": 124,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "prediction": "name1",
	            "prediction": "a2",
            "confidence": "0.5",
            "num_dets": 1,
            "trained_thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-25/1585131695997/thumbnail/a3681beb-8bc.jpg",
	            "timestamp" : moment(parseInt("1585054543788", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	            let test2={

	            "id_tracker": 125,
	            "thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-19/123/thumbnail/72a28c03-190.jpg",
	            "folder_path": "/home/odt/Downloads/facenet/contributed/save_dir/16",
	            "prediction": "name2",
	            "confidence": parseInt("0.5" * 100) + ' %',
            "num_dets": 1,
            "trained_thumbnail": "http://localhost:8004/media/uploads/tracker/2020-03-25/1585121263621/thumbnail/982614f7-bfe.jpg",
            'full_img' : 'sas',
	            "timestamp" : moment(parseInt("1585054643788", 10)).tz('Asia/Ulaanbaatar').format('ll, LTS'),
	            }
	           // list.push(test2,test,test1);
	           // list.reverse();
	           if(this.search){
					
					for(let i of l_search){
						let list_s = {
							'thumbnail' 		: i.thumbnail,
							'id_tracker' 		: i.id,
							'folder_path' 		: i.folder_path,
							'prediction' 		: i.prediction,
							'confidence' 		: parseInt(i.confidence * 100) + ' %',
							'num_dets' 			: i.num_dets,
							'trained_thumbnail' : i.trained_thumbnail,	
							'device' 			: i.device,	
							'full_img' 			: i.fullimg,					
							'timestamp' 		: moment(parseInt(i.timestamp, 10)).tz('America/Bogota').format('ll, LTS'),
						}
						list1.push(list_s);
					}
					list = list1;
				}else{
					for(let i of lasts){ // last thumbnail axios
						if (i.prediction != 'Low_Score') {
							
							let list_l = {
								'thumbnail' 		: i.thumbnail,
								'id_tracker' 		: i.id,
								'folder_path' 		: i.folder_path,
								'prediction' 		: i.prediction,
								'confidence' 		: parseInt(i.confidence * 100) + ' %',
								'num_dets' 			: i.num_dets,
								'trained_thumbnail' : i.trained_thumbnail,
								'device' 			: i.device,	
								'full_img' 			: i.fullimg,
								'timestamp' 		: moment(parseInt(i.timestamp, 10)).tz('America/Bogota').format('ll, LTS'),

							}
							list.push(list_l);
						}
					}
						// list.slice().reverse()
						// console.log(socket, 'socket');
	  				for (let i of socket){ // new thumbnail socket{

						if (parseFloat(i.confidence) >= this.$confidence && i.prediction != 'Low_Score') {//>0.24 / 0.8

							let list_n = {
								'thumbnail' 		: this.$URL_face + i.url_photo,
								'id_tracker' 		: i.id_tracker,
								'folder_path' 		: i.folder_path,
								'prediction' 		: i.prediction,
								'confidence' 		: parseInt(i.confidence * 100) + ' %',
								'num_dets' 			: i.num_dets,
								'trained_thumbnail' : this.$URL_face + i.trained_thumbnail,
								'device' 			: i.device,	
								'full_img' 			: i.fullimg,
								'timestamp' 		: moment(parseInt(i.timestamp, 10)).tz('America/Bogota').format('ll, LTS'),
							}// let / Asia/Ulaanbaatar
						list.push(list_n)
						} //if
					}//for

				}//else
					// for (var i = 0; i < list.length; i++) {
					// 	for (var j = 0; j < list.length; i++) {
					// 		if (list[i].timestamp>=list[j]timestamp) {

					// 		}
					// 	}
					// }
					list.sort(function(a,b){
					  // Turn your strings into dates, and then subtract them
					  // to get a value that is either negative, positive, or zero.
					  return new Date(b.timestamp) - new Date(a.timestamp);
					});
				list.reverse();
				return list;
  			}, //list

  			currentUser(){
		      return this.$store.state.auth.user;
		    }, // currentUser

  		},//computed
  		mounted(){ 
			this.list_faces();
			this.$nextTick( () =>{
				this.onResize();
			})

			if (localStorage.getItem('list_devices')) {
				this.list_devices = JSON.parse(localStorage.getItem('list_devices'));
			}

			if (localStorage.getItem('confidence_face')) {
				this.confidence   = JSON.parse(localStorage.getItem('confidence_face'));
				this.$confidence  = this.confidence;
			}

			let arr = []
	  		// var data={}
	  		

	  		let  vm = this
	  		//console.log(socket, 'ofice')
	  		/*socket.onmessage = function (e) { 
				
				

			}//socket*/

			EventBus.$on('events_face', vm.bus.events_face =  (msg)=>{
				// let data = JSON.parse(e.data);
				/*if (msg && msg.host_id) {
					msg.device = vm.render_device(msg.host_id);
				}*/
				vm.faces.push(msg);

				if (vm.faces && vm.faces.length > 150 ){
					vm.faces.shift();
				}

			})
		},//mounted

		beforeDestroy(){
			if (this.bus) {
				let vm = this;
				EventBus.$off('events_face', this.bus.events_face);
			}
		}, // beforeDestroy
	};
</script>
